(function () {
  var R = window.ress || { root: '/', cartAdd: '/cart/add', cart: '/cart' };
  var root = R.root.charAt(R.root.length - 1) === '/' ? R.root : R.root + '/';

  function openCart() { if (location.hash !== '#cart') location.hash = 'cart'; }
  function closeCart() { if (location.hash === '#cart') location.hash = ''; }

  function refreshCart() {
    return fetch(root + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer']; if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('cart-panel'), cur = document.getElementById('cart-panel');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        return fetch(R.cart + '.js').then(function (r) { return r.json(); });
      })
      .then(function (c) {
        if (!c) return;
        document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = c.item_count; });
      });
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.classList || !f.classList.contains('js-ajax')) return;
    if (e.submitter && e.submitter.name === 'checkout') return;
    e.preventDefault();
    var btns = document.querySelectorAll('button[form="' + f.id + '"], button[type=submit]');
    var mine = [].filter.call(btns, function (b) { return b.form === f; });
    mine.forEach(function (b) { b.disabled = true; });
    fetch(R.cartAdd + '.js', { method: 'POST', body: new FormData(f), headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { alert(res.j.description || res.j.message || 'Could not add to bag'); return; }
        return refreshCart().then(openCart);
      })
      .catch(function () { f.submit(); })
      .finally(function () { mine.forEach(function (b) { b.disabled = false; }); });
  });

  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-cart-open]');
    if (o) { e.preventDefault(); openCart(); return; }
    var c = e.target.closest('[data-cart-close]');
    if (c) { e.preventDefault(); closeCart(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('.sizes input[type=radio]') && t.dataset.price) {
      document.querySelectorAll('[data-price]').forEach(function (n) { if (n.tagName !== 'INPUT') n.textContent = t.dataset.price; });
    }
    if (t.matches('.js-sort select')) t.form.submit();
  });

  // dropdown menus: first tap opens on touch screens; click outside closes
  document.querySelectorAll('nav.main li.has > a').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var li = a.parentElement;
      if (window.matchMedia('(hover: none)').matches && !li.classList.contains('open')) {
        e.preventDefault();
        document.querySelectorAll('nav.main li.open').forEach(function (x) { x.classList.remove('open'); });
        li.classList.add('open');
      }
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('nav.main')) document.querySelectorAll('nav.main li.open').forEach(function (x) { x.classList.remove('open'); });
  });

  document.querySelectorAll('[data-recs]').forEach(function (el) {
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recs]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    });
  });
})();